<template>
  <app-content style="position: relative;">
    <Loading text="操作中~" :loading="loading"></Loading>
    <!-- 这里同样用auditMemberId，判断是否是审核单据不如用voucher.locked严谨 -->
    <div class="mask"
         v-if="User.role ==='View' || (form.id && (voucher.auditMemberId && currentAccountSets.voucherReviewed))"></div>
    <div class="h-panel" :style="{ width: panelWidth, margin: '0 auto', paddingTop: '20px' ,backgroundColor: bgColor}">
      <img v-if="form.id &&  (voucher.auditMemberId && currentAccountSets.voucherReviewed)" class="auditpic" src="@/assets/audit.png" alt="已审核">
      <!-- 资金生成凭证编辑的时候，不需要显示凭证号按钮等等的内容，因为这并非实际保存，只是修改凭证行的数据 -->
      <div v-if="editCashierVoucher" style="padding:0 20px">
        <Button color="primary" @click="editCashierSubmit()">确认</Button>
      </div>
      <!--发票生成凭证编辑的时候，不需要显示凭证号按钮等等的内容，因为这并非实际保存，只是修改凭证行的数据 -->
      <div v-if="editIncVoucher" style="padding:0 20px">
        <Button color="primary" @click="editIncSubmit()">确认</Button>
      </div>
      <div v-if="!editCashierVoucher && !editIncVoucher" class="padding-right-left">
        <Row type="flex" :space-x="10">
          <template v-if="assetsData">
            <Cell>
              <Button :disabled="!canSave" color="primary" @click="save(false,'assets')" :loading="loading">保存
              </Button>
              <Button @click="$emit('close')">返回</Button>
              <!-- //固定资产合并 -->
              <Button text-color="red" @click="mergeSame()">合并相同项</Button>
            </Cell>
          </template>
          <template v-else>
            <Cell v-if="User.role !='View'">
              <template v-if="isCheck">
                <Button v-if="form.id && currentAccountSets.voucherReviewed" color="primary" @click="audit" :loading="loading">审核</Button>
                <Button v-if="isCheck" @click="$emit('close')">返回</Button>
                <Button v-if="allowSkipCumCheck" color="primary" @click="$emit('success')" :loading="loading">
                  不保存，下一步
                </Button>
                <Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading">
                  保存
                </Button>
              </template>
              <template v-else>
                <Button :disabled="!canSave" color="primary" @click="save(true)" :loading="loading" v-if="!form.id">
                  保存并新增
                </Button>
                <!-- jxd新增按钮锁定不受审核影响，故去除禁用属性 -->
                <Button v-if="form.id"
                        color="primary" @click="toNew()">
                  新增
                </Button>
                <Button :disabled="!canSave || !!(voucher.auditMemberId && currentAccountSets.voucherReviewed)"
                        color="primary" @click="save(false)" :loading="loading">
                  保存
                </Button>
                <!--如果没有单据id那么证明单据还没保存，那这个时候不需显示删除按钮 -->
                <Button v-if="form.id" :disabled="!!(voucher.auditMemberId && currentAccountSets.voucherReviewed)"
                        color="primary" @click="remove(voucher)" :loading="loading">
                  删除
                </Button>
                <template v-if="form.id && currentAccountSets.voucherReviewed">
                  <Button v-if="(voucher.auditMemberId && currentAccountSets.voucherReviewed)" color="primary"
                          @click="cancelAudit" :loading="loading">
                    取消审核
                  </Button>
                  <Button v-else color="primary" @click="audit" :loading="loading">审核</Button>
                </template>
                <DropdownMenu
                        button
                        class="h-btn-green"
                        :datas="{loadTpl:'使用模板',saveTpl:'存为模板'}"
                        @clickItem="trigger">
                  更多
                </DropdownMenu>
              </template>
            </Cell>
            <Cell v-if="!isCheck && form.id">
              <Button class="h-btn" color="yellow" @click="openModal = true">打印</Button>
            </Cell>
            <!-- jxd提示行，提示损益类科目的方向异常 -->
            <Cell>
              <span v-if="profitSubjectMsg" class="h-tag h-tag-red msg">{{profitSubjectMsg}}</span>
            </Cell>
            <Cell :flex="1" class="text-right" v-if="!isCheck">
              <!-- jxd快捷键提醒 -->
              <vxe-button title="护眼模式" @click="changeEye()" style="margin-right:10px" status="success" icon="vxe-icon-eye-fill" circle></vxe-button>
              <div style="display:inline-block"><SwitchList @change="switchChange" v-model="value1" :datas="param1" :small="true"></SwitchList></div>
              <div class="keyboard-class">
                <i style="padding:10px" class="fa fa-keyboard-o" @mouseover="showTooltip" @mouseleave="hideTooltip">快捷键</i>
                <div v-if="isTooltipVisible" class="tooltip">
                  <vxe-table
                    :data="tableDataKeyboard">
                    <vxe-column field="operate" title="操作" width="200"></vxe-column>
                    <vxe-column field="key" title="快捷键" width="200"></vxe-column>
                  </vxe-table>
                </div>
              </div>
              <!-- jxd如果是复制凭证过来的，去掉左右翻页功能 -->
              <ButtonGroup v-if="!copy">
                <Button :loading="loading" @click="before(false)" size="s" content="上一条" icon="h-icon-left"></Button>
                <Button :loading="loading" @click="next(false)" size="s" content="下一条" icon="h-icon-right"></Button>
              </ButtonGroup>
            </Cell>
          </template>
        </Row>
        <Row class="margin-top" type="flex" :space-x="10">
          <Cell>
            <Select keyName="word" titleName="word" style="min-width: 70px" :deletable="false" :datas="voucherWords"
                    v-model="form.word" placeholder="记"/>
          </Cell>
          <Cell class="label">
            <NumberInput :min="1" v-model="form.code" style="display: inline-block"/>
            号
          </Cell>
          <Cell class="label">
            日期：
          </Cell>
          <Cell class="label">
            <DatePicker id="datePicker" :disabled="!!carryForward" :option="dpOps" :clearable="false" v-model="form.voucherDate"
                        format="YYYY-MM-DD"/>
          </Cell>
          <Cell class="label flex items-center">
            <DropdownCustom :toggle-icon="false" class-name="h-text-dropdown" placement="bottom-end">
              <span class="text-hover blue-color font-bold">
                <i class="fa fa-file-text"></i>
                备注
              </span>
              <template #content>
                <Textarea placeholder="请输入备注内容（最多255个字符）" :maxlength="255" v-model="form.remark" v-autosize rows="5"
                          style="width: 300px"></Textarea>
              </template>
            </DropdownCustom>
            <div class="ml-16px h-input-group w-150px">
              <span class="h-input-addon">附单据</span>
              <Input oninput="value=value.replace(/[^\d]/g,'')" id="receiptNum" v-model.number="form.receiptNum"/>
              <span class="h-input-addon">张</span>
            </div>
            <DropdownCustom :toggle-icon="false" class-name="h-text-dropdown" placement="bottom-end">
              <span class="text-hover blue-color font-bold ml-16px">
                <i class="fa fa-files-o"></i>
                附件
              </span>
              <template #content>
                <div class="w-400px">
                  <div class="p-8px flex justify-between items-center bg-gray3-color">
                    <span>附件列表</span>
                    <Uploader :showFileList="false" :accept="accept" displayType="file" multiple v-model="form.billList"
                              :option="billUploaderOptions">
                      <template #button>
                       <span class="text-hover">
                         <i class="fa fa-upload"></i> 点击上传
                       </span>
                      </template>
                    </Uploader>
                  </div>
                  <div class="h-150px">
                    <vxe-table ref="billListTable" :data="form.billList" :show-header="false" height="auto">
                      <vxe-column field="name">
                        <template #default="{row}">
                          <a :href="'/api'+row.url+'?name='+row.name" target="_blank">{{
                              row.name
                            }}</a>
                        </template>
                      </vxe-column>
                      <vxe-column width="40" align="center">
                        <template #default="{row,rowIndex}">
                          <i class="fa fa-trash text-hover" @click.stop="rmBill(row,rowIndex)"></i>
                        </template>
                      </vxe-column>
                    </vxe-table>
                  </div>
                </div>
              </template>
            </DropdownCustom>
          </Cell>
        </Row>
      </div>
      <!-- jxd@edit-row="onEditRow"父组件增加方法接受子组件当前操作的是哪一行，下标 -->
      <VoucherTable2 ref="voucherTable2" :bgColor="bgColor" :is-edit="!!form.id" :voucherDate="form.voucherDate" @childNewSubject="newSubject" @edit-row="onEditRow" @update="onItemsUpdate" :voucherDetails="voucherDetails"/>
      <div class="padding-right-left padding-bottom">
        <span style="padding-right: 6px;">制单人：{{ User.realName }}</span>
        <Button size="xs" @click="showPersonal()" icon="h-icon-edit" noBorder text-color="gray"></Button>
      </div>
    </div>
    <!-- 打印组件jxd -->
    <div>
      <p>
        <Modal v-model="openModal" v-bind="styleParams">
          <printDialog :params="{subparam: form.id,state:0}" @close="openModal=false"></printDialog>
        </Modal>
      </p>
    </div>
  </app-content>
</template>

<script>
import { defineProps } from 'vue';
import VoucherTable2 from "../../components/VoucherTable/index";
import {mapGetters, mapState} from 'vuex';
import {h} from 'vue';
import TemplateForm from "@/views/report/template/TemplateForm";
import {message} from "heyui.ext";
import manba from "manba";
import Common from "@/api/common";
import {layer} from "@layui/layer-vue";
import VoucherTplForm from "@/views/voucher/VoucherTplForm.vue";
import VoucherTplList from "@/views/voucher/VoucherTplList.vue";
import setting from "../../api/setting";
import voucher from "@api/voucher";
import printDialog from "@/components/PrintDialog";
import checkout from "@api/checkout";
import {add, floor} from "xe-utils";
import {clone, pick} from "xe-utils";
import Index from "@/views/personal/Index";
import IndexVue from '../personal/Index.vue';
import Decimal from 'decimal.js';
//const accept = "image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/pdf,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
const accept = "image/*";//改为只能上传图片
export default {
  name: "VoucherForm",
  components: {TemplateForm, VoucherTable2: VoucherTable2,printDialog},
  props: {
    allowSkipCumCheck: Boolean,//结转凭证是否允许不保存跳过
    editIncVoucher:Boolean,//发票z
    editIncVoucherData:Object,//发票z
    editCashierVoucher:Boolean,//jxdz资金凭证预览过来的
    editCashierVoucherData:Object,//jxdz资金凭证预览过来的数据
    internalTransfer:Boolean,//jxdz是否资金转账凭证
    transferData:Array,//资金内部转账生成凭证数据jxdz
    originPage:String,//jxd用于判断是不是结转损益或年结转凭证的页面弹出的
    voucherId: String,
    voucherDate: String,
    checkData: Object,
    assetsData: Array,
    profitCheckData: Array,
    yearCarryForward: Boolean,
    type: Object,
    copy: Boolean,
    redCanceling: Boolean,//是否红冲
    redSummary:Object,//红冲摘要数据
    insert:Boolean,//是否插入凭证
    originalVoucherId:String,//插入原凭证的id
    originaVoucherDate:String,//原凭证日期
    originaWord:String,//原凭证字
    originaCode:String,//原凭证号
    salaryVoucherData:Object,
    salaryDate:String,
    baseCheck:String,//jiaru 
  },
  computed: {
    ...mapState(['User', 'currentAccountSets', 'tabs']),
    ...mapGetters(['firstCheckoutDate', 'localCurrency']),
    canSave() {
      return this.voucherItems.length > 0
    },
    isCheck() {
      return !!this.checkData
    },
    acceptList() {
      return this.accept.split(",");
    },
    cacheKey() {
      return `voucher_cache_${this.currentAccountSets.id}`;
    }
  },
  data() {
    return {
      value1: '常规',
      param1: ['常规', '放大'],
      bgColor: '@white-color', // 初始背景色，
      eyes:false,
      panelWidth:"1090px",
      restrictionRelease : false,
      releaseRestriction : false,
      //弹出窗口组件样式
      styleParams: {
        closeOnMask: false,
        fullScreen: false,
        // hasCloseIcon:true,
        middle: true,
        hasMask: true,
        hasDivider: false,
        hasCloseIcon: false,
        draggable: false
      },
      //弹窗组件传递参数
      openModal: false,

      // 快捷键提醒jxd
      isTooltipVisible: false,
      tableDataKeyboard:[{operate:'凭证模板',key:'F4'},{operate:'保存并新增',key:'F12'},{operate:'保存',key:'Ctrl+S'},{operate:'新增',key:'Alt+N'},{operate:'切换下一单元格',key:'Tab / Enter'},{operate:'付单据数',key:'F7'},{operate:'日期选择',key:'F8'},{operate:'借贷金额互换',key:'空格'}],
      subjectList:[],
      profitSubjectMsg: "",//jxd
      accept,
      entityId: null,
      loading: false,
      isCopy: false,
      isRedCanceling:false,//是否红冲
      isInsert:false,//是否插入凭证
      carryForward: false,
      voucherWords: [],
      cachedDetails: [],
      voucherItems: [],
      voucherDetails: [],
      summaryVal:'',//jxd
      voucherTable: {voucherItems: []},
      dpOps: {
        start: manba().format(),
        end: manba().add(30, manba.YEAR).format('YYYY-MM-DD')
      },
      voucher: {},
      form: {
        id: null,
        remark: '',
        billList: [],
        word: '',
        code: '',
        voucherDate: '',
        receiptNum: 0,
        carryForward: false,
        checkTplId: null,
        salaryTplId: null,
        salaryDate: null,
      },
      billUploaderOptions: {
        onBeforeUpload: (file) => {
          if (!(this.acceptList.includes(file.type) || file.type.startsWith("image/"))) {
            message.error(`${file.name} 文件是不支持的上传类型~`);
            return false;
          }
          if (file.size > 100 * 1024 * 1024 * 1024) {
            message.error(`${file.name} 文件大小超出100M限制`);
            return false;
          }
          return true;
        },
        onChange: async (file) => {
          try {
            const fd = new FormData();
            fd.append("file", file);
            // ✅ 强制所有上传先进入临时目录，保存时再转正
            const isTemp = true;
            const {data, success, msg} = await Common.upload("voucher", fd, isTemp);
            console.log(this.form.billList,data)
            if (success) {
              // this.form.receiptNum = this.form.billList.length + 1;
              return data.path;
            } else {
              message.error(msg);
              throw new Error(msg);
            }
          } catch (error) {
            console.error(error);
            message.error(`${file.name}上传失败`);
            throw new Error();
          }
        }
      }
    }
  },
  mounted() {
    //开启快捷键监听jxd
    this.startKeyListener();
    this.startViewListener();
  },
  watch: {
    'form.billList': {
        handler(newList, oldList) {
             // jxd: 以下情况不同步 receiptNum:
            // 1. 编辑凭证初始化时(oldList 为空且 entityId 存在)
            // 2. 用户手动填写了单据数
            
            // 判断是否是初始化加载
            const isInitLoad = this.entityId && (!oldList || oldList.length === 0);
            
            if (!isInitLoad) {
                this.form.receiptNum = newList.length;
            }
        },
        deep: true
    },
    // 'form.word'(val, old) {
    //   if (!old && this.entityId) {
    //     return;
    //   }
    //   val && this.loadCode();
    // },
    'form.word'(val, old) {
      // 只有在以下情况才重新加载凭证号：
      // 1. 是新增凭证（!this.entityId）
      // 2. 是用户主动修改凭证字（old 存在且不为空）
      if (this.entityId && (!old || old === '')) {
        return;
      }
      val && this.loadCode();
    },
    voucherItems: {
      deep: true,
      handler(val) {
        if (!this.form.id) {
          localStorage.setItem(this.cacheKey, JSON.stringify(val));
        }
      }
    },
    'form.voucherDate'(val) {
      this.loadCode(val);
    }
  },
  methods: {
    switchChange(val){
      console.log(val)
      if(val.key == "放大"){
        this.panelWidth = "100%"
      }else{
        this.panelWidth = "1090px"
      }
      localStorage.setItem('bigOrSmall' + this.currentAccountSets.id,this.panelWidth);
    },
    changeEye(){
      if(this.eyes){
        this.eyes = false
        this.bgColor = '#ffffff'
      }else{
        this.eyes = true
        this.bgColor = '#faf9de'
      }
      localStorage.setItem('eye' + this.currentAccountSets.id,this.eyes ? '1' : '0');
    },
    mergeSame() {
  const mergedMap = {};

  this.voucherDetails.forEach(item => {
    const key = `${item.subjectId}-${item.balanceDirection}`;

    if (!mergedMap[key]) {
      // 初始化：金额用 Decimal(0)，但保留原始值用于后续计算
      const debit = item.debitAmount != null ? new Decimal(item.debitAmount) : new Decimal(0);
      const credit = item.creditAmount != null ? new Decimal(item.creditAmount) : new Decimal(0);
      const balance = item.subjectBalance != null 
        ? new Decimal(item.subjectBalance) 
        : debit.minus(credit); // 如果没有 subjectBalance，按借贷差计算

      mergedMap[key] = {
        subject: item.subject,
        summary: item.summary,
        subjectName: item.subjectName,
        subjectId: item.subjectId,
        debitAmount: debit,
        creditAmount: credit,
        isCarry: item.isCarry,
        subjectType: item.subjectType,
        balanceDirection: item.balanceDirection,
        subjectBalance: balance
      };
    } else {
      // 累加：使用 Decimal 精确计算
      const debitToAdd = item.debitAmount != null ? new Decimal(item.debitAmount) : new Decimal(0);
      const creditToAdd = item.creditAmount != null ? new Decimal(item.creditAmount) : new Decimal(0);

      mergedMap[key].debitAmount = mergedMap[key].debitAmount.plus(debitToAdd);
      mergedMap[key].creditAmount = mergedMap[key].creditAmount.plus(creditToAdd);
      // subjectBalance = 原余额 + (本次借 - 本次贷)
      mergedMap[key].subjectBalance = mergedMap[key].subjectBalance.plus(
        debitToAdd.minus(creditToAdd)
      );
    }
  });

  // 转换回普通对象数组，金额转为 number（保留2位小数）
  const mergedData = Object.values(mergedMap).map(entry => {
    return {
      ...entry,
      debitAmount: Number(entry.debitAmount.toFixed(2)),
      creditAmount: Number(entry.creditAmount.toFixed(2)),
      subjectBalance: Number(entry.subjectBalance.toFixed(2))
    };
  });

  this.voucherDetails = mergedData;
},
    //jxd接收VTable组件传递过来的添加科目成功数据
    newSubject(data){
      this.loadSubject();
    },
    //jxdz 发票预览的弹窗
    editIncSubmit(){
      if(this.formValid()){
        if(this.editIncVoucher){
          this.voucherItems.forEach(item => {
            if(!item.subject){
              const findRes = this.subjectList.find(items => items.id === item.subjectId);
              if(findRes){
                item.subject = findRes;
              }
            }
          })
          this.$emit('success', JSON.stringify(this.voucherItems))
          return;
        }
      }
    },
    //jxdz 资金预览的弹窗
    editCashierSubmit(){
      if(this.formValid()){
        if(this.editCashierVoucher){
          this.voucherItems.forEach(item => {
            if(!item.subject){
              const findRes = this.subjectList.find(items => items.id === item.subjectId);
              if(findRes){
                item.subject = findRes;
              }
            }
          })
          this.$emit('success', JSON.stringify(this.voucherItems))
          return;
        }
      }
    },
    //修改制单人jxd
    showPersonal(){
      layer.open({
        title: "个人信息设置",
        shadeClose: false,
        zIndex: 999,
        area: ['700px', '500px'],
        content: h(Index)
      });
},
    /**
     * jxd快捷键的悬浮显示控制
     */
     showTooltip() {
      this.isTooltipVisible = true;
    },
    hideTooltip() {
      this.isTooltipVisible = false;
    },
    /** jxd
     * 这里监听用户的键盘事件
     * F12 触发保存并新增 123
     * Ctrl+S 保存 17 + 83
     * Alt+N 新增 18 + 229
     * F4 凭证模板 115
     */
    startKeyListener() {
      document.addEventListener('keydown', this.handleKeydown);
    },
    //jxd监听页面器事件
    startViewListener(){
      window.addEventListener('popstate', this.handlePopstate);
    },
    //jxd通过监听页面，判断是否是凭证录入页面正在显示，如果是，则启用快捷键，如果不是则卸载
    handlePopstate (event) {
      // 处理路由变化逻辑
      if (event.target.location.hash !== "#VoucherForm") {
        this.$store.dispatch('init');//切换页面，获得最新的init，帮助更新账期，是否有10月账期，但录入了11月的凭证
        this.pageName = true;
        document.removeEventListener('keydown', this.handleKeydown);
      } else {
        this.pageName = false;
        this.loadSubject();
        document.addEventListener('keydown', this.handleKeydown);
      }
    },
    handleKeydown(event) {
      if(this.editIncVoucher || this.editCashierVoucher){
        return
      }
      if(event.keyCode == 123){
        event.preventDefault()
        this.save(true)
      }else if(event.ctrlKey && event.keyCode == 83){
        event.preventDefault()
        this.save(false)
      }else if(event.altKey && event.key.toLowerCase() === 'n'){
        event.preventDefault()
        this.toNew()
      }else if(event.keyCode == 115){
        event.preventDefault()
        this.trigger('loadTpl')
      }else if(event.keyCode == 118){ // F7 - 新增
        event.preventDefault()
        this.focusReceiptNumInput()
      }else if(event.keyCode == 119){ // F7 - 新增
        event.preventDefault()
        this.focusDatePicker()
      }
    },
    focusDatePicker(){
      const input = document.getElementById('datePicker').querySelector('.h-datetime-show');
      if (input) {
        input.click()
        input.focus()
      }
    },
    // 聚焦附单据数量输入框
    focusReceiptNumInput() {
      const input = document.getElementById('receiptNum');
      if (input) {
        input.focus();
      }
    },
    //jxd先检测所选凭证是否可以删除，不能删除的直接过滤掉，就不提交了
    isDeleteCheck(data){
      //第一步先判断是否启用审核，如果启用审核，则先检测要删除的凭证是否审核
      if(this.currentAccountSets.voucherReviewed){
        //启用审核，先检测所选择的凭证是否审核了
        let arrayData = [];
          //这里判断data是不是数组
          if(Array.isArray(data)){
            data.forEach(item => {
              arrayData.push(item);
            })
          }else{
            arrayData.push(data);
          }
          // console.log(arrayData);
          let auditDataArray = [];
          arrayData.forEach(item => {
            //如果凭证的年月与已结账月份相同，则不可以删除
            if(item.auditMemberId){
              //已经审核的凭证存储到数组中
              auditDataArray.push({
                // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                id: item.id,
                code: item.code,
                word: item.word,
                year: item.year,
                month: item.month
              });
            }
          });
          if(auditDataArray.length > 0){
            //所选凭证有启用审核的
            auditDataArray.forEach(item => {
              this.$Message({
                type:"warn",
                text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month} 已经审核，不可删除，请先反审核或重新选择要删除的凭证！`
              });
            });
          }else{
            //没有启用审核，直接进行账套期间检测
            return this.loadClosedMonthList().then(filteredData => {
              let arrayData = [];
              //这里判断data是不是数组
              if(Array.isArray(data)){
                data.forEach(item => {
                  arrayData.push(item);
                })
              }else{
                arrayData.push(data);
              }
              // console.log(arrayData);
              //arrayData凭证数组 filteredData结账数组 matchedData不可删除的单独数组
              let matchedData = [];
              for(let i = 0;i<arrayData.length;i++){
                for(let j = 0;j<filteredData.length;j++){
                  // 如果找到匹配项（即凭证的年月与已结账月份相同）
                  if (filteredData[j].checkYear === arrayData[i].year && filteredData[j].checkMonth === arrayData[i].month) {
                    // 将匹配项添加到新数组中
                    matchedData.push({
                      // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                      id: arrayData[i].id,
                      code: arrayData[i].code,
                      word: arrayData[i].word,
                      year: arrayData[i].year,
                      month: arrayData[i].month
                    });
                    arrayData.splice(i, 1);
                    i--;
                    break;
                  }
                }
              }
              // 输出所有不能删除的凭证信息,和可以删除的凭证信息数组
              let flg;
              // let flg = arrayData.length === 0 ? false : true;
              if(arrayData.length === 0 && matchedData.length !== 0){
                //只有不能删除的
                flg = 1;
              }else if(arrayData.length !== 0 && matchedData.length === 0){
                //只有可以删除的
                flg = 2;
              }else{
                //有可以删除的和不能删除的
                flg = 3;
              }
              let res = {"isDelete":arrayData,"noDelete":matchedData,"flg":flg}
              // console.log(res)
              return res;
            });
          }
      }else{
        //没有启用审核，直接进行账套期间检测
        return this.loadClosedMonthList().then(filteredData => {
          let arrayData = [];
          //这里判断data是不是数组
          if(Array.isArray(data)){
            data.forEach(item => {
              arrayData.push(item);
            })
          }else{
            arrayData.push(data);
          }
          // console.log(arrayData);
          //arrayData凭证数组 filteredData结账数组 matchedData不可删除的单独数组
          let matchedData = [];
          for(let i = 0;i<arrayData.length;i++){
            for(let j = 0;j<filteredData.length;j++){
              // 如果找到匹配项（即凭证的年月与已结账月份相同）
              if (filteredData[j].checkYear === arrayData[i].year && filteredData[j].checkMonth === arrayData[i].month) {
                // 将匹配项添加到新数组中
                matchedData.push({
                  // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                  id: arrayData[i].id,
                  code: arrayData[i].code,
                  word: arrayData[i].word,
                  year: arrayData[i].year,
                  month: arrayData[i].month
                });
                arrayData.splice(i, 1);
                i--;
                break;
              }
            }
          }
          // 输出所有不能删除的凭证信息,和可以删除的凭证信息数组
          let flg;
          // let flg = arrayData.length === 0 ? false : true;
          if(arrayData.length === 0 && matchedData.length !== 0){
            //只有不能删除的
            flg = 1;
          }else if(arrayData.length !== 0 && matchedData.length === 0){
            //只有可以删除的
            flg = 2;
          }else{
            //有可以删除的和不能删除的
            flg = 3;
          }
          let res = {"isDelete":arrayData,"noDelete":matchedData,"flg":flg}
          // console.log(res)
          return res;
        });
      }
    },
    //jxd通过查询已经结账的月份，判断凭证是否可以删除
    loadClosedMonthList() {
      return checkout.list().then(({ data }) => {
        // const filteredData = data.filter(item => item.status !== 0);
        // 0是从未结账，1是已经反结账的，2是目前已经结账的
        const filteredData = data.filter(item => item.status !== 0 && item.status !== 1);
        return filteredData;
      });
		},
    //jxd删除凭证
    remove(row) {
      if(Object.keys(row).length === 0){
        this.$Message({
          type:"error",
          text:"凭证还没保存！"
        })
        return;
      }
      this.$Confirm("确认删除?").then(() => {
        // 需要将异步操作转换为同步处理，使用async/await
        (async () => {
          let res = await this.isDeleteCheck(row);
          if(res.flg == 2){
            ///有可以删除的
            const loadId = layer.load(2);
            voucher.delete([pick(row, ['id', 'year', 'month',"word","code"])]).then(({data}) => {
              this.$Message("删除成功~")
              this.next(true);
            }).finally(() => layer.close(loadId))
          }else if(res.flg == 1){
            //没有可以删除的
            res.noDelete.forEach(item => {
              this.$Message({
                type:"warn",
                text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month} 期间已结账，不能删除~`
              });
            });
          }
        })();
      });
    },
    //接收到子组件当前操作的行的下标jxd，然后看看当前操作的是不是损益类科目进行检测
    onEditRow({ rowIndex, rowData }) {
      // console.log(rowData,rowIndex)
      if(!rowData.subject){return};
      let msg = "";
      this.profitSubjectMsg = msg;
      if ((rowData.subject.type === "损益" || rowData.subject.type === "收入" || rowData.subject.type === "支出") && this.originPage !== "profitPage") {  
        if(rowData.subject.balanceDirection === "借" && rowData.creditAmount){
          //损益类科目借方，在贷方录入数据了
          msg ="第"+ (rowIndex+1) + "行" + rowData.subject.name + "损益类科目请录入红字凭证！"
          this.profitSubjectMsg = msg;
        }else if(rowData.subject.balanceDirection === "贷" && rowData.debitAmount){
          //损益类科目贷方，在借方录入数据了
          msg ="第"+ (rowIndex+1) + "行" + rowData.subject.name + "损益类科目请录入红字凭证！"
          this.profitSubjectMsg = msg;
        }
      }
    },
    onItemsUpdate(val) {
      this.voucherItems = val;
      this.voucherTable.jfTotal = floor(val.reduce((total, row) => add(total, (row.debitAmount || 0)), 0), 2)
      this.voucherTable.dfTotal = floor(val.reduce((total, row) => add(total, (row.creditAmount || 0)), 0), 2)
    },
    loadVoucherWords() {
      setting.voucherWord.list().then(({data}) => {
        this.voucherWords = data || [];
        if (!this.form.word && !this.entityId) {
          this.form.word = data.find(value => value.isDefault).word
        }
      })
    },
    loadCode(voucherDate = null) {
      if(!this.isInsert){
        if (this.voucher && this.voucher.id && voucherDate && manba(this.voucher.voucherDate).format("YYYYMM") === manba(voucherDate).format("YYYYMM")) {
          this.form.code = this.voucher.code;
        } else if (this.form.word) {
          this.form.voucherDate && voucher.loadCode({
            word: this.form.word,
            currentAccountDate: voucherDate || this.form.voucherDate
          }).then(({data}) => {
            this.form.code = data
          })
        }
      }
    },
    formValid() {
      console.log(this.voucherItems)
      this.voucherItems = this.voucherItems.filter(item =>   
        item.summary || item.subjectId || item.debitAmount || item.creditAmount  
      ).filter(Boolean);

      if (!this.form.voucherDate) {
        this.$Message("亲，请选择日期！");
        return false;
      }

      if (!this.form.code) {
        this.$Message("亲，请输入编号！");
        return false;
      }

      if (this.voucherItems.length == 0) {
        this.$Message("亲，第1行不能为空！");
        return false;
      }

      if (this.checkItem("摘要", 'summary') || this.checkItem("科目", 'subjectId') || this.checkItem("金额")) {
        return false;
      }

      if (this.voucherTable.jfTotal !== this.voucherTable.dfTotal) {
        this.$Message("亲，借贷不平衡！");
        return false;
      }

      // 检查科目是否为明细科目
      for (let index = 0; index < this.voucherItems.length; index++) {
        const item = this.voucherItems[index];
        const findRes = this.subjectList.find(items => items.id === item.subjectId);
        console.log(findRes)
        console.log("222",item)
        if(findRes == undefined){
          this.$Message({
            type: "error",
            text: `第${index + 1}行的科目不存在，请查证后尝试！`
          });
        }
        if (!findRes.leaf) {
          this.$Message({
            type: "error",
            text: `第${index + 1}行科目-${findRes.name}是明细科目，不能录入凭证！`
          });
          return false; // 直接终止整个验证过程
        }
        if(findRes.auxiliaryAccounting.length > 0){
          if(item.auxiliary){
            if(item.auxiliary.length <= 0){
              this.$Message({
                type: "error",
                text: `第${index + 1}行科目-${findRes.name}是辅助核算科目，请选择核算的项目！`
              });
              return false; // 直接终止整个验证过程
            }
          }else{
            this.$Message({
                type: "error",
                text: `第${index + 1}行科目-${findRes.name}是辅助核算科目，请选择核算的项目！`
              });
              return false; // 直接终止整个验证过程
          }
        }
        //额外检测一下jxd以防万一
        if(!findRes.enableForCurrency){
          //不是外币
          if(item.exchangeRate){
            this.$Message({
                type: "error",
                text: `第${index + 1}行科目-${findRes.name}不是外币核算科目，不能录入汇率！`
              });
              return false; // 直接终止整个验证过程
          }
        }
        if(findRes.unit == ""){
          //不是数量
          if(item.num){
            this.$Message({
                type: "error",
                text: `第${index + 1}行科目-${findRes.name}不是数量核算科目，不能录入数量！`
              });
              return false; // 直接终止整个验证过程
          }
        }
        //凭证录入界面先选择一个科目，然后到科目设置吧科目改成外币后，在回来能直接保存，导致外币科目信息变本币
        if(findRes.enableForCurrency){
          if(findRes.currencyAccounting[0] != item.currencyId){
            this.$Message({
              type: "error",
              text: `第${index + 1}行科目-${findRes.name}是外币科目，需要录入外币信息,请重新选择科目并录入外币信息！`
            });
              return false; // 直接终止整个验证过程
          }
        }
      }

      // 检查数量是否正确不做提醒，只检测，并帮助修改
      for (let index = 0; index < this.voucherItems.length; index++) {
        const item = this.voucherItems[index];
        if(item.num > 0){
          if (item.creditNum !== 0 && item.debitNum !== 0) {
            if (item.creditNum > 0 &&  item.debitNum > 0) {
              if (item.creditAmount > 0) {
                item.debitNum = 0;
              } else {
                item.creditNum = 0;
              }
            }
          }
        }
      }
      //jxd原币检测
      for(let i =0;i<this.voucherItems.length;i++){
        const item = this.voucherItems[i];
        if(item.amountFor != 0){
          if (item.creditAmountFor !== 0 && item.debitAmountFor !== 0) {
            if ((item.creditAmountFor > 0 || item.creditAmountFor < 0) && (item.debitAmountFor > 0 || item.debitAmountFor < 0)) {
              if (item.creditAmount > 0 || item.creditAmount < 0) {
                item.debitAmountFor = 0;
              } else {
                item.creditAmountFor = 0;
              }
            }
          }
        }
      }
      return true;
    },
    async save(next, type = "") {
      // 新增：临时附件转正（新增凭证场景）
      const tempAttachments = this.form.billList.filter(item => item.url.includes("/temp/"));
      if (tempAttachments.length > 0) {
        // 逐个转正
        for (const item of tempAttachments) {
          await Common.confirmUpload(item.url); // 调后端转正接口
          // 更新前端url为正式路径
          item.url = item.url.replace("temp/", "");
        }
      }

      // 原有：编辑场景的附件删除逻辑（不变）
      let oldAttachments = this.voucher.billList || [];
      let newAttachments = this.form.billList || [];
      console.log("新旧数组",oldAttachments,newAttachments)
      let deletedUrls = oldAttachments
        .filter(old => !newAttachments.some(nu => nu.url === old.url))
        .map(item => item.url);
      console.log(deletedUrls,"待删除数组")
      // 🔥 串行依次删除，保证全部成功
      if (deletedUrls.length > 0) {
        for (const url of deletedUrls) {
          try {
            await Common.deleteAttachment(url);
            console.log("✅ 删除成功:", url);
          } catch (err) {
            console.log("❌ 删除失败:", url);
          }
        }
      }
      setTimeout(() => {  
        if (!this.formValid()) {
          return
        }
        //统一检测不管是编辑还是新增，都要先检测，如果是非盈利准则，只有两个科目，借限定，贷非限定，则认为这是一张限定性净资产转为非限定性净资产凭证 xf
        if(this.User.accountSets.accountStandard == "NONGOVERNMENTAL" || this.User.accountSets.accountStandard == "NONGOVERNMENTAL2026"){
          console.log("进来",this.voucherItems)
          let a = this.voucherItems.filter(item => item.subjectName == "限定性净资产" && item.debitAmount != null && item.debitAmount != 0)
          let b = this.voucherItems.filter(item => item.subjectName == "非限定性净资产" && item.creditAmount != null && item.creditAmount != 0)
          if(a.length > 0 && b.length > 0 && this.voucherItems.length == 2){
            this.restrictionRelease = true;
            console.log("进来1")
            //this.releaseRestriction = false;
          }else{
            this.restrictionRelease = false;
            //this.releaseRestriction = true;
            console.log("进来2")
          }

          let a1 = this.voucherItems.filter(item => item.subjectName == "限定性净资产" && item.creditAmount != null && item.creditAmount != 0)
          let b1 = this.voucherItems.filter(item => item.subjectName == "非限定性净资产" && item.debitAmount != null && item.debitAmount != 0)
          if(a1.length > 0 && b1.length > 0 && this.voucherItems.length == 2){
            this.releaseRestriction = true;
            console.log("进来3")
          }else{
            this.releaseRestriction = false;
            console.log("进来4")
          }
        }
        //jxd保存并插入凭证
        if(this.isInsert){
          let formData = Object.assign({}, this.form, {
            details: this.voucherItems,
            carryForward: this.carryForward,
            yearCarryForward: this.yearCarryForward,
            createMember: this.User.id,
            restrictionRelease : this.restrictionRelease,
            releaseRestriction : this.releaseRestriction //xf
          });
          voucher.saveAndInsert(formData).then(({success, data}) => {
            if (success) {
              localStorage.removeItem(this.cacheKey);
              message("保存成功~")
              //jxd保存凭证成功后，将凭证的信息，保存到voucher中
              this.voucher = data;
              if (type === 'assets') {
                this.$emit('success', data.id)
                return
              }
              if (success && !this.form.id) {
                this.isCopy = false;
                if (next) {
                  if (!this.isCheck) {
                    this.toNew();
                  } else {
                    this.$emit('success')
                  }
                } else {
                  this.entityId = data.id;
                  this.form.id = data.id;
                }
              } else if (success) {
                this.loading = false;
                this.$emit('success')
              }
            }
          }).catch(() => {
            this.loading = false;
          }).finally(() => this.loading = false);
        }else{
          if (!this.formValid()) {
            return
          }
          let formData = Object.assign({}, this.form, {
            details: this.voucherItems,
            carryForward: this.carryForward,
            yearCarryForward: this.yearCarryForward,
            createMember: this.User.id,
            restrictionRelease : this.restrictionRelease,
            releaseRestriction : this.releaseRestriction  //xf
          });
          // console.log(this.voucherItems)
          if (this.type) {
            formData.checkTplId = this.type.id;
          }else {
            formData.checkTplId = null
          }
          if (this.salaryVoucherData) {
            formData.salaryTplId = this.salaryVoucherData.id;
            formData.salaryDate = this.salaryDate;
          }else {
            formData.salaryTplId = null
            formData.salaryDate = null;
          }
          this.loading = true;
          // let id = this.isInsert ? `?id=${this.originalVoucherId}` : '';////插入凭证jxd如果需要插入位置原凭证id
          voucher[this.entityId ? 'update' : 'save'](formData).then(({success, data}) => {
            if (success) {
              localStorage.removeItem(this.cacheKey);
              message("保存成功~")
              //jxd保存凭证成功后，将凭证的信息，保存到voucher中
              this.voucher = data;
              //jxd资金凭证生成
              if(this.internalTransfer){
                this.$emit('success', data.id)
                return;
              }
              if (type === 'assets') {
                this.$emit('success', data.id)
                return
              }
              if (success && !this.form.id) {
                this.isCopy = false;
                if (next) {
                  this.form.id = data.id;//jxd结转页面的第一个自定义结转项目，如果启用审核，保存后需要把id提交，否则不能继续审核
                  if (!this.isCheck) {
                    this.toNew();
                  } else {
                    this.$emit('success')
                  }
                }else if(this.salaryVoucherData){
                  this.loading = false;
                  this.$emit('success')
                }else {
                  this.entityId = data.id;
                  this.form.id = data.id;
                }
              } else if (success) {
                this.loading = false;
                this.$emit('success')
              }
            }
          }).catch(() => {
            this.loading = false;
          }).finally(() => {
            this.loading = false;
            localStorage.setItem("voucherDate" + this.currentAccountSets.id,this.form.voucherDate);
          });
        }
      }, 1000);
    },
    checkItem(name, field) {
      let i = 0, len = this.voucherItems.length, row = -1;
      for (; i < len; i++) {
        if ((field && !this.voucherItems[i][field]) || (!field && !this.voucherItems[i].debitAmount && !this.voucherItems[i].creditAmount)) {
          row = i + 1;
          break;
        }
      }

      if (row > -1) {
        this.$Message(`亲，第${row}行，请输入${name}！`);
        return true;
      }
    },
    before(isDel) {
      this.loading = true;
      voucher.beforeId({code: this.form.code, voucherDate: this.form.voucherDate, word: this.form.word}).then(({data}) => {
        //翻页时候去掉损益类科目提示
        this.profitSubjectMsg = "";
        if (data) {
          this.entityId = data;
          this.init();
        } else {
          if (isDel) {
            this.toNew();
            this.$Message("亲，已经没有上一条啦！")
          }else{
            this.$Message("亲，已经没有上一条啦！")
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    //del，用于接受是否是删除后调用的next，如果是删除后，调用next，当后面没有凭证的情况下，则跳到向上翻页
    //如果跳到向上翻页，也啥都没有了，那就执行新增一个空白凭证jxd
    next(isDel) {
      this.loading = true;
      voucher.nextId({code: this.form.code, voucherDate: this.form.voucherDate, word: this.form.word}).then(({data}) => {
        //翻页时候去掉损益类科目提示
        this.profitSubjectMsg = "";
        if (data) {
          this.entityId = data;
          this.init();
        } else {
          if(isDel){
            this.before(true);
          }else{
            this.$Message("亲，已经没有下一条啦！")
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    init() {
      if (this.voucherId || this.entityId) {
        console.log("修改来的")
        this.loading = true;
        voucher.load(this.entityId || this.voucherId).then(({data}) => {
          // console.log(data)
          //复制的时候，去除ID
          if (this.isCopy) {
            // console.log(data)
            data.locked = false;
            data.id = null;
            data.auditMemberId = null;
            data.carryForward = null;
            data.code = null;
            data.voucherDate = manba(this.currentAccountSets.currentAccountDate).endOf(manba.MONTH).format();
          }
          data.details.forEach(val => {
            val.originalCreditAmount = val.creditAmount;
            val.originalDebitAmount = val.debitAmount;
            val.amountFor = val.debitAmountFor || val.creditAmountFor || 0;//外币金额
            val.isCarry = this.isCopy ? true : false;//余额计算需要传递字段，用于判断单据的借方贷方是否参与运算jxd
          })
          if(this.isRedCanceling){//jxd红冲情况下，将所有改成负数（不应该是负数，应该是反向）
            data.details.forEach(val => {
              val.summary = '冲销' + this.redSummary.voucherDate + this.redSummary.word + '-' + this.redSummary.code + '_' + val.summary;
              if(val.creditAmount != 0){val.creditAmount = -val.creditAmount;}
              if(val.debitAmount != 0){val.debitAmount = -val.debitAmount;}
              if(val.creditAmountFor){val.creditAmountFor = -val.creditAmountFor;}
              if(val.debitAmountFor){val.debitAmountFor = -val.debitAmountFor;}
              if(val.creditNum){val.creditNum = -val.creditNum;}
              if(val.debitNum){val.debitNum = -val.debitNum;}
              if(val.originalDebitAmount){val.originalDebitAmount = -val.originalDebitAmount;}
              if(val.originalCreditAmount){val.originalCreditAmount = -val.originalCreditAmount;}
              if(val.num != 0){val.num = -val.num;}
              if(val.amountFor != 0){val.amountFor = -val.amountFor}
            })
          }
          this.voucherDetails = data.details;
          // console.log("编辑详情",this.voucherDetails)
          this.voucher = data;
          this.form = {
            id: data.id,
            auditMemberId: data.auditMemberId,
            word: data.word,
            remark: data.remark,
            voucherDate: data.voucherDate,
            carryForward: data.carryForward,
            billList: data.billList ? JSON.parse(JSON.stringify(data.billList)) : [],///AAAASSSS
            code: data.code,
            receiptNum:data.receiptNum//jxd付单据数量没有更新上去
          };
          //jxd编辑结转损益凭证，损益结转标识不能丢
          if(data.carryForward){
            this.carryForward = true;
          }else{
            this.carryForward = false;
          }
          if (this.isCopy) {
            this.loadCode();
          }
        }).finally(() => this.loading = false)
      }else if(this.isInsert){
        //插入凭证jxd
        this.form.voucherDate = this.originaVoucherDate;
        this.form.code = this.originaCode;
        this.form.word = this.originaWord;
      } else {
        this.form.voucherDate = localStorage.getItem('voucherDate' + this.currentAccountSets.id) || manba(this.currentAccountSets.currentAccountDate).endOf(manba.MONTH).format();
        this.$nextTick(() => {
          this.voucherDetails = this.cachedDetails || [];
        })
      }

      //结转凭证初始化
      this.checkInit();
      this.profitCheck();
      this.assetsInit();
      //jxdz资金转账凭证初始化
      this.transfer();
      //jxdz资金生成凭证后预览编辑过来的
      this.editCashier();
      //jxdz发票生成凭证后预览编辑过来的
      this.editInc();

      //工资凭证初始化
      if (this.salaryVoucherData) {
        this.initSalary();
      }

      this.loadVoucherWords();
    },

    //jxdz发票转账凭证预览编辑过来的
    editInc(){
     if(this.editIncVoucher){
      //  console.log(this.editCashierVoucherData);
      //  console.log(this.form)
       this.$nextTick(() => {
         this.voucherDetails = this.editIncVoucherData.details || [];
       })
     }
    },

    //jxdz资金转账凭证预览编辑过来的
    editCashier(){
     if(this.editCashierVoucher){
      //  console.log(this.editCashierVoucherData);
      //  console.log(this.form)
       this.$nextTick(() => {
         this.voucherDetails = this.editCashierVoucherData.details || [];
       })
     }
    },

    //jxdz资金转账
    transfer(){
      if(this.internalTransfer){
        this.$nextTick(() => {
          this.voucherDetails = this.transferData || [];
        })
      }
    },

    initSalary() {
      if (!this.salaryVoucherData) return;
      this.form.voucherDate = this.salaryDate
      this.form.word = this.salaryVoucherData.word
      let details = [];
      this.salaryVoucherData.items.forEach(item => {
        // let sub = data.subject[item.subjectId];
        let detail = {
          // originalCreditAmount : creditAmount,
          // originalDebitAmount : debitAmount,
          summary: this.salaryVoucherData.title,
          subjectName: item.subjectName,
          subjectId: item.subjectId,
          [item.direction === '贷' ? 'creditAmount' : 'debitAmount']: item.amount,
          [item.direction === '贷' ? 'originalCreditAmount' : 'originalDebitAmount']: item.amount, //jxd计算余额需要的信息
        }
        detail.creditAmount = detail.creditAmount ? detail.creditAmount : 0; //jxd计算余额需要的信息
        detail.debitAmount = detail.debitAmount ? detail.debitAmount : 0; //jxd计算余额需要的信息
        detail.originalCreditAmount = detail.originalCreditAmount ? detail.originalCreditAmount : 0; //jxd计算余额需要的信息
        detail.originalDebitAmount = detail.originalDebitAmount ? detail.originalDebitAmount : 0; //jxd计算余额需要的信息
        detail.isCarry = true;//是否是结转生成的行信息 //jxd计算余额需要的信息，工资的也算是结转类型的凭证
        details.push(detail)
      });
      this.$nextTick(() => {
        this.voucherDetails = details || [];
      })
    },
    assetsInit() {
      if (this.assetsData) {
        const codeList = Array.from(new Set(this.assetsData.map(val => val.assetsSubjectCode)));
        this.form.voucherDate = manba(this.voucherDate).endOf(manba.MONTH).format();
        setting.subject.listByCode(codeList).then(({data}) => {
          let details = [];
          this.assetsData.forEach(assets => {
            const subjectCode = assets.assetsSubjectCode;
            const subject = data[subjectCode]; // 👈 先取出来

            // ⚠️ 关键：检查 subject 是否存在
            if (!subject) {
              message.error(`${subjectCode}科目在系统中不存在，请检查固定资产科目配置！~`);
            }

            details.push({
              summary: assets.summary,
              subject: data[assets.assetsSubjectCode],
              subjectName: `${data[assets.assetsSubjectCode].code}-${data[assets.assetsSubjectCode].name}`,
              subjectId: data[assets.assetsSubjectCode].id,
              debitAmount: assets.debitAmount || null,
              creditAmount: assets.creditAmount || null,
              isCarry:true,//是否是结转生成的行信息 //jxd计算余额需要的信息
            });
          })
          this.voucherDetails = details || [];
        });
      }
    },
    checkInit() {//常规结转凭证
      if (this.checkData && !this.profitCheckData) {
        // this.carryForward = !!this.type;
        this.carryForward = false;//jxd常规结转不属于损益，故因此为false
        this.form.voucherDate = manba(this.checkData.checkYear + "-" + this.checkData.checkMonth).endOf(manba.MONTH).format();
        let {title: name} = this.type;
        let details = [];
        checkout.loadTplData({
          checkYear: this.checkData.checkYear,
          checkMonth: this.checkData.checkMonth,
          tplId: this.type.id,
        }).then(({data}) => {
          this.checkTplId = this.type.id;
          data.itemList.forEach(amount => {
            let sub = data.subject[amount.subjectId];
            let detail = {
              // originalCreditAmount : creditAmount,
              // originalDebitAmount : debitAmount,
              summary: `${name} 第${this.checkData.checkMonth}期`,
              subject: sub,
              subjectName: `${sub.code}-${sub.fullName}`,
              subjectId: sub.id,
              [amount.balanceDirection === '贷' ? 'creditAmount' : 'debitAmount']: amount.amount,
              [amount.balanceDirection === '贷' ? 'originalCreditAmount' : 'originalDebitAmount']: amount.amount, //jxd计算余额需要的信息
            }
            detail.creditAmount = detail.creditAmount ? detail.creditAmount : 0; //jxd计算余额需要的信息
            detail.debitAmount = detail.debitAmount ? detail.debitAmount : 0; //jxd计算余额需要的信息
            detail.originalCreditAmount = detail.originalCreditAmount ? detail.originalCreditAmount : 0; //jxd计算余额需要的信息
            detail.originalDebitAmount = detail.originalDebitAmount ? detail.originalDebitAmount : 0; //jxd计算余额需要的信息
            detail.isCarry = true;//是否是结转生成的行信息 //jxd计算余额需要的信息
            details.push(detail)
          });

          this.$nextTick(() => {
            this.voucherDetails = details || [];
          })
        });
      }
    },
    profitCheck() {//损益结转凭证
      if (this.profitCheckData) {
        this.carryForward = true;
        // this.yearCarryForward = pr
        this.form.voucherDate = manba(this.checkData.checkYear + "-" + this.checkData.checkMonth).endOf(manba.MONTH).format();
        this.form.voucherDate = manba(this.checkData.checkYear + "-" + this.checkData.checkMonth).endOf(manba.MONTH).format();
        
        // 结转损益判断下是否开启审核，否则不带审核信息
        if(this.User.accountSets.voucherReviewed){
          this.form.auditMemberId = this.User.id;
          this.form.auditDate = manba().format();
        }

        // let name = this.checkData.checkMonth != "12" ? "结转损益" : "年度结转";
        let name = this.checkData.checkMonth == "12" ? (this.baseCheck == "baseCheck" ? "结转损益" : "年度结转") : "结转损益";
        let details = [];

        this.profitCheckData.forEach(sub => {
          //jxd汇率，单价处理损益凭证
          let price = 0;
          if(sub.balanceQuantity){
            price = (Number(sub.fcAmount) / Number(sub.balanceQuantity)).toFixed(4);
          }else{
            price = ''
          }
          let exchangeRate = 0;
          if(sub.balanceFor){
            exchangeRate = (Number(sub.fcAmount) / Number(sub.balanceFor)).toFixed(4);
          }else{
            exchangeRate = ''
          }
          let detail = {
            isProfitCheck:true,//jxd是否结转损益的或年结转凭证，让外币汇率，不需要重新加载
            summary: `第${this.checkData.checkMonth}期 ${name}`,
            subject: sub.subject,
            auxiliary: sub.auxiliary,
            auxiliaryDetailId: sub.auxiliaryDetailId,
            auxiliaryTitle: sub.auxiliaryTitle,
            currencyId: this.localCurrency.id,
            subjectName: `${sub.code}-${sub.fullName}`,
            num : sub.balanceQuantity,//jxd数量损益凭证
            amountFor :sub.balanceFor,//jxd外币损益
            price: price,//jxd汇率，单价处理损益凭证
            exchangeRate: exchangeRate,//jxd汇率，单价处理损益凭证
            subjectId: sub.subjectId,
            [sub.balanceDirection === '借' ? 'originalCreditAmount' : 'originalDebitAmount']: sub.fcAmount, //jxd计算余额需要的信息
          };
          detail.creditAmount = detail.creditAmount ? detail.creditAmount : 0; //jxd计算余额需要的信息
          detail.debitAmount = detail.debitAmount ? detail.debitAmount : 0; //jxd计算余额需要的信息
          detail.originalCreditAmount = detail.originalCreditAmount ? detail.originalCreditAmount : 0; //jxd计算余额需要的信息
          detail.originalDebitAmount = detail.originalDebitAmount ? detail.originalDebitAmount : 0; //jxd计算余额需要的信息
          detail.isCarry = true;//是否是结转生成的行信息 //jxd计算余额需要的信息
          details.push(Object.assign({}, detail, {
            [sub.balanceDirection === '借' ? 'creditAmount' : 'debitAmount']: sub.fcAmount,
            [sub.balanceDirection === '借' ? 'creditAmountFor' : 'debitAmountFor']: sub.balanceFor,
            [sub.balanceDirection === '借' ? 'creditNum' : 'debitNum']: sub.balanceQuantity,
          }));
        });
        this.$nextTick(() => {
          console.log("回显数据,",details)
          this.voucherDetails = details || [];
        })
      }
    },
    audit() {
      this.$Confirm("亲，确认要审核吗?").then(() => {
        this.loading = true;
        // console.log(this.voucher);
        voucher.audit({
          checked: [this.voucher.id],
          year: this.voucher.year,
          month: this.voucher.month
        }).then(() => {
          this.init();
          this.$Message("审核成功！");
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    cancelAudit() {
      this.$Confirm("亲，确认要取消审核吗?").then(() => {
        this.loading = true;
        voucher.cancelAudit({
          checked: [this.voucher.id],
          year: this.voucher.year,
          month: this.voucher.month
        }).then(() => {
          this.init();
          this.$Message("取消审核成功！");
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    toNew() {
      console.log("执行1")
      if (this.voucherId) {
        console.log("执行2")
        //jxd各种新增前必须卸载键盘快捷键监听，不卸载，在触发快捷键的时候，为什么还会提交之前的凭证
        document.removeEventListener('keydown', this.handleKeydown);
        this.$store.commit('closeTab', {key: "VoucherForm", title: "新增凭证"})//jxd先关闭，再打开，防止有缓存
        setTimeout(() => {
          this.$store.commit('newTab', {key: "VoucherForm", title: "新增凭证"})
        }, 200);
        this.$emit('close');
      } else {
        console.log("执行")
        //jxd各种新增前必须卸载键盘快捷键监听，不卸载，在触发快捷键的时候，为什么还会提交之前的凭证
        document.removeEventListener('keydown', this.handleKeydown);
        this.$store.commit('refreshTab', {key: "VoucherForm", title: "新增凭证"})
      }
    },
    saveTpl() {
      if (this.formValid()) {
        let layerId = layer.open({
          title: "新建凭证模板",
          shadeClose: false,
          closeBtn: false,
          zIndex: 1000,
          area: ['400px', 'auto'],
          content: h(VoucherTplForm, {
            entity: Object.assign({}, this.form, {details: this.voucherItems, createMember: this.User.id}),
            onClose: () => {
              layer.close(layerId);
            },
            onSuccess: () => {
              layer.close(layerId);
            }
          })
        });
      }
    },
    loadTpl() {
      let layerId = layer.open({
        title: "凭证模板",
        shadeClose: false,
        closeBtn: 1,
        zIndex: 1000,
        area: ['1120px', 'auto'],
        content: h(VoucherTplList, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: (tpl,subjectMap) => {
            //jxd给模版添加数据
            tpl.details.forEach((item, index) => {
              let sub = subjectMap[item.subjectId];
              item.creditAmount = item.creditAmount ? item.creditAmount : 0; //jxd计算余额需要的信息
              item.debitAmount = item.debitAmount ? item.debitAmount : 0; //jxd计算余额需要的信息
              item.originalCreditAmount = item.originalCreditAmount ? item.originalCreditAmount : 0; //jxd计算余额需要的信息
              item.originalDebitAmount = item.originalDebitAmount ? item.originalDebitAmount : 0; //jxd计算余额需要的信息
              item.isCarry = true;//是否是结转生成的行信息 //jxd计算余额需要的信息

              item.subject = sub;
            })
            this.voucherDetails = tpl.details
            layer.close(layerId);
          },
          onBack: () => {
            layer.close(layerId);
          }
        })
      });
    },
    trigger(key) {
      this[key].call(this);
    },
    rmBill(row, rowIndex) {
      this.form.billList.splice(rowIndex, 1);
      this.$refs.billListTable.remove(row);
      //jxd移除附件，修改附件数量
      this.form.receiptNum = this.form.billList.length;
      message.success("已移除，保存后生效~")
    },
    loadSubject() {
			//jxd这里的科目选择应该是所有科目
			setting.subject.listAll().then(({data}) => {
				this.subjectList = data;
			})
		},
  },
  created() {
    // console.log(this.voucher.locked,this.currentAccountSets.voucherReviewed)
    //加载缓存凭证数据，未保存的凭证会放到缓存中，jxd，他这样写好吗？暂时去掉
    // const cachedDetails = localStorage.getItem(this.cacheKey);
    // if (cachedDetails) {
    //   this.cachedDetails = JSON.parse(cachedDetails);
    // }
    if(localStorage.getItem('eye' + this.currentAccountSets.id)){
      if(localStorage.getItem('eye' + this.currentAccountSets.id) == 1){
        this.eyes = true
        this.bgColor = '#faf9de'
      }
    }
    if(localStorage.getItem('bigOrSmall' + this.currentAccountSets.id)){
      if(localStorage.getItem('bigOrSmall' + this.currentAccountSets.id) == '100%'){
        this.panelWidth = '100%'
        this.value1 = "放大"
      }else{
        this.panelWidth = '1090px'
        this.value1 = "常规"
      }
    }  
    this.loadSubject();
    this.isInsert = this.insert;//插入凭证
    this.isCopy = this.copy;
    this.isRedCanceling = this.redCanceling; //是否红冲
    if (!this.isCopy) {
      this.entityId = this.voucherId;
    }
    this.dpOps.start = this.firstCheckoutDate;
    this.dpOps.end = manba(this.dpOps.start).add(30, manba.YEAR).format('YYYY-MM-DD');
    this.init();
  },
  beforeUnmount() {
    console.log('Component will be unmounted soon');
    // 在组件销毁前执行一些操作jxd,卸载监听快捷键
    document.removeEventListener('keydown', this.handleKeydown);
    // 在需要卸载事件监听器的时候调用下面的代码
    window.removeEventListener('popstate', this.handlePopstate);
  }
}
</script>

<style scoped>

/* 快捷键部分样式jxd */
.keyboard-class{
  display:inline-block;
  position: relative;
}
.tooltip {
  /* 设置你的提示框样式 */
  position: absolute;
  left: -160px;
  z-index: 999;
}
.keyboard-class>.fa-keyboard-o {
  color: #679dfd; /* 默认字体颜色为蓝色 */
}

.keyboard-class>.fa-keyboard-o:hover {
  color: #f60; /* 鼠标悬停时字体颜色变红色 */
}
/* jxd css样式调整 */
.h-dropdowncustom{
  margin-top: -2px;
}
.h-tag.h-tag-red.msg{
  height: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
}
.mask {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  bottom: 0;
  top: 110px;
}

.auditpic {
  position: absolute;
  z-index: 100;
  right: 30px;
  top: 50px;
}

.h-btn.h-btn-green {
  background-color: #2080f0;
  border-color: #167bef;
  color: #ffffff;
}
.h-btn.h-btn-green:hover {
  border-color: #167bef;
  background-color: #2080f0;
}

</style>
